export default __webpack_public_path__ + "static/media/Rundstav Ek.8a433ad1.jpg";